import {BaseContainerModel} from '../base-container.model';
import {bl_sfa_contact_hdr_RowClass} from '../../dbschema';


export class SfaContactHdrContainerModel extends BaseContainerModel {
  bl_sfa_contact_hdr: bl_sfa_contact_hdr_RowClass = new bl_sfa_contact_hdr_RowClass();
}
